import React from "react";
import LoadMoreButton from "@/components/atomics/load-more-button";
import NFTCard from "@/components/atomics/nft-card";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { NftCard, CollectionStats, ItemInCollection } from "@/types/collection";

interface NFTSectionProps {
  nftCards: NftCard[];
  isLoadingItems: boolean;
  handleLoadMore: () => void;
  stats: CollectionStats;
  items: ItemInCollection[];
  previewImage: string;
}
const NFTSection = ({
  nftCards,
  isLoadingItems,
  handleLoadMore,
  stats,
  items,
  previewImage,
}: NFTSectionProps) => {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-white pt-[20px] pb-[20px] px-[30px]">
      <div className="pb-[23px]">
        <span className="text-[30px] text-black">ALREADY CREATED</span>
      </div>
      <div className="w-full grid grid-cols-4 gap-[10px] transition-all duration-500 ease-in-out">
        {nftCards.map((item, index) => (
          <NFTCard
            key={`nft-${item.id}-${index}`}
            className={clsx(
              "w-full flex-shrink-0 transition-all duration-300 ease-in-out hover:cursor-pointer",
              isLoadingItems && "animate-pulse opacity-60",
              !isLoadingItems && "opacity-100"
            )}
            onClick={() => {
              navigate(`/nft/${item.mintedAddress}`);
            }}
            {...item}
            image={previewImage}
          />
        ))}
      </div>
      {stats.minted_nfts > items.length && (
        <LoadMoreButton
          isLoading={isLoadingItems}
          hasMore={items.length < stats.minted_nfts}
          onLoadMore={handleLoadMore}
        />
      )}
    </div>
  );
};

export default NFTSection;
